exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(//fonts.googleapis.com/earlyaccess/notosanstc.css);", ""]);
exports.push([module.id, "@import url(//fonts.googleapis.com/earlyaccess/notosanssc.css);", ""]);

// module
exports.push([module.id, "html{font-size:14px!important}body{font-family:Noto Sans TC,Noto Sans SC,sans-serif!important;letter-spacing:.5px;box-sizing:border-box;font-size:1rem;color:#333;height:100%}:-webkit-input-placeholder{color:#999;font-weight:400}:-ms-input-placeholder,::-ms-input-placeholder{color:#999;font-weight:400}::placeholder{color:#999;font-weight:400}:-moz-placeholder,::-moz-placeholder{color:#999;font-weight:400}::-moz-placeholder{opacity:1}.Select-placeholder{color:#999;font-weight:400}strong,table>thead>tr>th{font-weight:500}label{font-weight:400}a[download]{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.basic__helpBlock{font-size:9pt;font-weight:400;color:#bababa}#tooltip.tooltip.in{opacity:1}#tooltip .tooltip-inner{background:#353d45;line-height:18px;text-align:left;border-radius:2px;padding:8px 15px;max-width:fit-content}#tooltip.tooltip.bottom .tooltip-arrow{border-bottom-color:#353d45}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/stylesheets/basic.css
 ** module id = 2215
 ** module chunks = 73
 **/